console.log("init Proteus treatments -- v1.02")

waitForElement('.shopify_subscriptions_app_container').then(subscription_app => {
  document.querySelector('body').insertAdjacentHTML("afterbegin", `
    <style>
    .product-info__price{
      display: none;
    }
    </style>  
  `);
}).catch();

// support for [BRE-09] PP upsells

/* 
LIDS (prod id: 6578299830317)  
const x19_lid: 39397496324141
const x24_lid: 39397502484525
const x30_lid: 39397505990701

PITS (prod_id: 7219796508717)
X19 / Corten: 41234257870893
X19 / Stainless: 41234257903661
X24 / Corten: 41234325700653
X24 / Stainless: 41234325733421
X30 / Corten: 41234325766189
X30 / Stainless: 41234325798957
X42 / Corten: 41860588306477
X42 / Stainless: 4186059574481
*/

// mapping PIT variant IDs → their matching LID
// Map PIT variant IDs → corresponding LID (product + variant)
const pit_lid_map = {
  // X19 pits
  41234257870893: { prod: 6578299830317, var: 39397496324141 },
  41234257903661: { prod: 6578299830317, var: 39397496324141 },

  // X24 pits
  41234325700653: { prod: 6578299830317, var: 39397502484525 },
  41234325733421: { prod: 6578299830317, var: 39397502484525 },

  // X30 pits
  41234325766189: { prod: 6578299830317, var: 39397505990701 },
  41234325798957: { prod: 6578299830317, var: 39397505990701 },

  // X42 pits: add mapping when you have the LID(s)
  // 41860588306477: { prod: 6578299830317, var: ??? },
  // 4186059574481: { prod: 6578299830317, var: ??? },
};

document.addEventListener("cart:change", async (event) => {
  window.cart_data = event.detail.cart;

  const lids_to_add = new Set();
  const prods_to_add = new Set();

  for (const item of window.cart_data.items) {
    const match = pit_lid_map[item.variant_id];
    if (match) {
      lids_to_add.add(String(match.var));
      prods_to_add.add(String(match.prod));
    }
  }

  // Build CSV strings; if no matches, set to "none"
  const pp_var_ids  = lids_to_add.size ? Array.from(lids_to_add).join(",") : "none";
  const pp_prod_ids = prods_to_add.size ? Array.from(prods_to_add).join(",") : "none";

  // Desired attributes payload (strings only)
  const desiredAttrs = {
    pp_multi_offer: "true",
    pp_var_ids,
    pp_prod_ids,
    pp_coll_ids: "none",
    pp_discount_amount: "10",
    pp_discount_type: "percentage",
  };

  // (Optional) Skip network call if nothing changes
  const curr = window.cart_data.attributes || {};
  const unchanged =
    curr.pp_multi_offer === desiredAttrs.pp_multi_offer &&
    curr.pp_var_ids === desiredAttrs.pp_var_ids &&
    curr.pp_prod_ids === desiredAttrs.pp_prod_ids &&
    curr.pp_coll_ids === desiredAttrs.pp_coll_ids &&
    curr.pp_discount_amount === desiredAttrs.pp_discount_amount &&
    curr.pp_discount_type === desiredAttrs.pp_discount_type;

  if (unchanged) return;

  try {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: desiredAttrs }),
    });
    const data = await res.json();
    console.log("Cart attributes updated:", data?.attributes ?? data);
  } catch (err) {
    console.error("Error updating cart:", err);
  }
});


if(getParam("cart") == "open"){
  waitForElement('[aria-controls="cart-drawer"]').then(cart_trigger => {
    cart_trigger.click();
  }).catch()
}

/* START support for [BRE-01] */
let free_burger_press = () => {
  
  window.sessionStorage.setItem("[BRE-01] activate Burger Press GWP", true);
  let burger_press_var_id = 42490257834029;

  // logic for all NOT /cart pages
  let assess_cart = (cart_total) => {

    waitUntil(() => {
      return typeof window.cart_data != "undefined" && typeof window.cart_data.items != "undefined";
    }).then(() => {

      let burger_press_in_cart = window.cart_data.items.some(item => item.title.toLowerCase().includes('breeo burger press'));
      if(!burger_press_in_cart && window.cart_data.total_price >= 39800 && !window.sessionStorage.getItem("[BRE-01] Burger Press GWP added")){
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: burger_press_var_id, 
              quantity: 1
            }]
          })
        }).then(response => response.json()).then(cart => {
          console.log("assess_cart item added"),
          window.sessionStorage.setItem("[BRE-01] Burger Press GWP added", true);
          window.location.href = `/discount/FREEPRESS?redirect=${window.location.pathname}?cart=open`;
        }).catch(error => {
          console.error('Error adding item to cart:', error);
        });
        
      }
      
    }).catch();
    
  };

  // init
  assess_cart();

  document.addEventListener('rebuy:cart.change', (event) => { 
    assess_cart(event.detail.cart.subtotal()); 
  });

  document.addEventListener('rebuy:cart.ready', (event) => { 
    // assess_cart(event.detail.cart.subtotal());
  });
  
};

if(window.sessionStorage.getItem("[BRE-01] activate Burger Press GWP") ||
  getParam("free_burger_press") ||
  getParam("utm_campaign").toLowerCase().indexOf("burger press") > -1){
  free_burger_press();
}

window.addEventListener("klaviyoForms", function(e) { 
  console.log("klaviyoForms event", e.detail)
  if (e.detail.type == 'submit' && e.detail.formId == "W2VaPf") {
    free_burger_press();
  }
});
/* START support for [BRE-01] */